import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import './Legal.css'

export default function TermsConditions() {
  return (
    <div className="legal-page">
      <Header />
      
      <main className="legal-content">
        <div className="container">
          <Link to="/" className="back-link">
            <ArrowLeft size={20} />
            Back to Home
          </Link>
          
          <div className="legal-card">
            <h1>Terms & Conditions</h1>
            <p className="legal-intro">Welcome to <strong>Digital vCard</strong></p>
            <p className="legal-date">Last updated: December 2024</p>
            
            <p>By accessing our website, you agree to the following terms:</p>
            
            <section className="legal-section">
              <h2>1. Services</h2>
              <p>
                We offer digital services such as website development and business vCards. 
                All service details will be discussed and confirmed with the customer before payment.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>2. Payments</h2>
              <p>
                All payments must be completed before the final delivery of the service.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>3. Delivery</h2>
              <p>
                Project timelines will be shared individually based on the scope and 
                complexity of each project.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>4. Intellectual Property</h2>
              <p>
                All content on this website belongs to <strong>Digital vCard</strong> and 
                cannot be reused without permission.
              </p>
            </section>
            
            <section className="legal-section">
              <h2>5. Contact</h2>
              <p>
                For any questions regarding these terms, contact us at:
              </p>
              <ul className="contact-list">
                <li>Email: support@santhoshsharuk.me</li>
                <li>Phone: +91 81109 60489</li>
              </ul>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  )
}
